import { render } from "./VoteManagementSystem.vue?vue&type=template&id=10f427d7"
import script from "./VoteManagementSystem.vue?vue&type=script&lang=js"
export * from "./VoteManagementSystem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__